import './SettingsClient.scss'

import React, {Component} from 'react';
import SettingsSelect from './SettingsSelect.js'

import { push } from 'react-router-redux'

import {
  BUYER_TYPE
} from 'common/constants'

const SettingsClient = ({dispatch, settings, onSelect}) => {

  const lowVolume = <span className="SettingsSelect__additional SettingsSelect__additional--danger">Low Volume</span>

  const additionalMap = {
    "seller": lowVolume,
    "lease-other": lowVolume
  }

  return (
    <div className="SettingsClient">
      <div className="Settings__label">Client Types</div>
      <SettingsSelect multiselect={true} options={BUYER_TYPE} selected={settings.client_categories} rightAdditionalMap={additionalMap} onClick={onSelect} />
    </div>
  )
}

export default SettingsClient
